const textSendEmail = (isCheckout) => {
  const title = isCheckout
    ? 'Sera enviado um e-mail com o link de pagamento'
    : 'Deseja realmente reenviar a cobrança?'

  const description = isCheckout
    ? 'O link de pagamento será enviado para os e-mails dos clientes cadastrados no contrato.'
    : "Será enviado um novo e-mail com a cobrança para o cliente. <br /><br /> Caso queira gerar uma nova cobrança, clique em <strong>'NOVA COBRANÇA'</strong> na listagem de cobranças que fica na tela de contrato."

  return {
    title,
    description,
    buttonLabel: isCheckout ? 'Enviar link' : 'Reenviar cobrança',
  }
}

export default textSendEmail
